import React from 'react';
import { Link } from 'react-router-dom';

const Opportunities = () => {
  return (
    <section className="bg-white section-wrapper px-6 py-12 md:px-20 text-deep-navy">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-primary mb-6 text-center">
          Join the BetterTurns Movement
        </h2>
        <p className="text-lg leading-relaxed mb-8 text-center">
          As BetterTurns grows, we’ll be looking for mission-driven individuals
          to help us build the future of independent retail.
        </p>

        <ul className="space-y-4 text-lg">
          <li>
            <strong className="text-primary">
              🔧 Full Stack Developer (Future Need)
            </strong>
            <p className="text-gray-700 text-base">
              Help us build and scale the BetterTurns ERP and POS platform using
              modern, cloud-native technologies.
            </p>
          </li>
          <li>
            <strong className="text-primary">
              📊 Data Analyst / Retail Insights (Future Need)
            </strong>
            <p className="text-gray-700 text-base">
              Work with store-level and co-op-wide data to uncover actionable
              insights and shape smarter decisions.
            </p>
          </li>
          <li>
            <strong className="text-primary">
              📢 Community & Training Coordinator (Future Need)
            </strong>
            <p className="text-gray-700 text-base">
              Lead onboarding sessions, develop educational content, and build
              relationships with co-op members.
            </p>
          </li>
          <li>
            <strong className="text-primary">
              🛍️ Retail Merchandising Advisor (Future Need)
            </strong>
            <p className="text-gray-700 text-base">
              Support independent stores with guidance on assortments, vendor
              promos, and retail best practices.
            </p>
          </li>
        </ul>

        <div className="text-center mt-10">
          <p className="mt-4">
            Interested in helping shape the movement?{' '}
            <a
              href="mailto:gabe@betterturns.com"
              className="text-sunshine-yellow font-semibold hover:text-warm-orange"
            >
              Email us at gabe@betterturns.com
            </a>
          </p>
          <Link
            to="/"
            className="text-sunshine-yellow font-semibold hover:text-warm-orange"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Opportunities;
